import { InventoryTransactionsModel } from '../../models/InventoryTransactionsModel'
import { useTimers } from '../../store/timers'
import { storeToRefs } from 'pinia'
/**
 * This function gathers transactions to sync. If a store is actively logging
 * time against it, transactions associated to that store_id are ignored
 *
 */
export const transactions = async (last_sync: Date) => {
  const { transactionsToSync } = InventoryTransactionsModel()
  const { getActiveParentTimer } = storeToRefs(useTimers())
  const ignoreStoreId = getActiveParentTimer.value
    ? getActiveParentTimer.value.data.store_id
    : undefined
  return await transactionsToSync(last_sync, ignoreStoreId)
}

/**
 * Given a list of successful transactions on the portal, we can flag
 * them on the device so they are not grabbed for a sync.
 */
export const flagSuccesfulTransactions = async (uuids: string[]) => {
  const { flagSuccess } = InventoryTransactionsModel()
  await flagSuccess(uuids)
}
